// @Version: 1.0.0
export enum FC_TEXT_INPUT {
   TEXT = "text"
}